<template>
  <div class="auth-pep">
    <div v-if="status === 'loading'" class="auth-pep__content">
      <b-spinner
        variant="primary"
        label="Autenticando..."
        class="auth-pep__spinner"
      />

      <h4>Autenticando</h4>

      <p>Aguarde enquanto validamos o acesso pelo e-SUS APS PEC.</p>
    </div>

    <div v-else-if="status === 'success'" class="auth-pep__content">
      <div class="auth-pep__success-icon">
        <i class="icofont-check-circled"></i>
      </div>

      <h4>Autenticação realizada com sucesso</h4>

      <p>Os dados enviados pelo e-SUS APS PEC foram validados corretamente.</p>
    </div>

    <div v-else-if="status === 'error'" class="auth-pep__content">
      <div class="auth-pep__error-icon">
        <i class="icofont-exclamation-circle"></i>
      </div>

      <h4>Acesso negado</h4>

      <p>{{ mensagemErro }}</p>

      <p class="auth-pep__error-help">
        Se o problema persistir, entre em contato com o setor de Informática.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AuthPep',

  data() {
    return {
      status: 'loading',
      mensagemErro: '',
    }
  },
  async mounted() {
    await this.autenticarViaPec()
  },
  methods: {
    /**
     * Verifica se a página está sendo acessada dentro de um iframe.
     *
     * @returns {boolean}
     */
    acessoPermitidoPeloPec() {
      return window.self !== window.top
    },

    /**
     * Autentica a integração utilizando os dados enviados pelo e-SUS APS PEC.
     */
    async autenticarViaPec() {
      const estaDentroDoIframe = this.acessoPermitidoPeloPec()

      if (!estaDentroDoIframe) {
        this.exibirErro(
          'Esta página deve ser acessada através do e-SUS APS PEC.'
        )
        return
      }

      this.status = 'loading'
      this.mensagemErro = ''

      const parametrosUrl = new URLSearchParams(window.location.search)

      const identificadorPublico = String(
        this.$route.params.identificador_publico || ''
      ).trim()

      const documentoProfissional = String(
        this.$route.query.documentoProfissional ||
          parametrosUrl.get('documentoProfissional') ||
          ''
      ).trim()

      const documentoCidadao = String(
        this.$route.query.documentoCidadao ||
          parametrosUrl.get('documentoCidadao') ||
          ''
      ).trim()

      const pecTimestamp = String(
        this.$route.query.pec_timestamp ||
          parametrosUrl.get('pec_timestamp') ||
          ''
      ).trim()

      const pecSign = String(
        this.$route.query.pec_sign || parametrosUrl.get('pec_sign') || ''
      ).trim()

      const cnes = String(
        this.$route.query.cnes || parametrosUrl.get('CNES') || ''
      ).trim()

      if (
        !identificadorPublico ||
        !documentoProfissional ||
        !documentoCidadao ||
        !pecTimestamp ||
        !pecSign ||
        !cnes
      ) {
        this.exibirErro(
          'Os dados de integração enviados pelo PEC estão incompletos.'
        )

        return
      }

      try {
        const { data } = await this.$apiPep.get(
          `/pep/${identificadorPublico}`,
          {
            params: {
              documentoProfissional,
              documentoCidadao,
              pec_timestamp: pecTimestamp,
              pec_sign: pecSign,
              cnes: cnes,
            },
          }
        )

        if (!data.token) {
          throw new Error('Token do PEP não retornado pela API.')
        }

        await this.$store.dispatch('pep/salvarAutenticacao', {
          token: data.token,
          identificadorPublico,
        })

        await this.$router.replace({
          name: 'pep-atendimento-360',
          params: {
            identificador_publico: identificadorPublico,
          },
        })

        /*
         * Enquanto a tela cidadão-360 não estiver implementada,
         * exibe apenas a confirmação de autenticação.
        //  */
        // this.exibirSucesso()
      } catch (error) {
        await this.$store.dispatch('pep/logout')

        const mensagem =
          error.response?.data?.message ||
          'Não foi possível autenticar o acesso pelo PEC.'

        this.exibirErro(mensagem)
      }
    },

    /**
     * Exibe a confirmação de autenticação na página.
     */
    exibirSucesso() {
      this.status = 'success'
      this.mensagemErro = ''
    },

    /**
     * Exibe o erro de autenticação dentro da página.
     *
     * @param {string} mensagem
     */
    exibirErro(mensagem) {
      this.status = 'error'
      this.mensagemErro = mensagem
    },
  },
}
</script>

<style lang="scss" scoped>
.auth-pep {
  min-height: 100vh;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 2rem;
  background-color: #f8f9fa;

  &__content {
    width: 100%;
    max-width: 460px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1rem;
    padding: 2rem;
    text-align: center;
    background-color: #fff;
    border: 1px solid #e9ecef;
    border-radius: 0.75rem;
    box-shadow: 0 0.25rem 1rem rgba(0, 0, 0, 0.06);
    margin: 50px auto;
  }

  &__spinner {
    width: 3rem;
    height: 3rem;
  }

  &__success-icon,
  &__error-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 4rem;
    height: 4rem;
    font-size: 2.5rem;
    border-radius: 50%;
  }

  &__success-icon {
    color: #28a745;
    background-color: rgba(40, 167, 69, 0.1);
  }

  &__error-icon {
    color: #dc3545;
    background-color: rgba(220, 53, 69, 0.1);
  }

  h4 {
    margin: 0;
    font-weight: 600;
    color: #343a40;
  }

  p {
    max-width: 360px;
    margin: 0;
    color: #6c757d;
    line-height: 1.5;
  }
}
</style>
